(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Product_trDeleteController',Product_trDeleteController);

    Product_trDeleteController.$inject = ['$uibModalInstance', 'entity', 'Product_tr'];

    function Product_trDeleteController($uibModalInstance, entity, Product_tr) {
        var vm = this;

        vm.product_tr = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Product_tr.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
